import { useEffect } from "react";

import { useSelector } from "react-redux";
import { matchPath, useLocation } from "react-router-dom";

import routes from "routes";

const getSelectedConversation = ({ chatsData }) =>
  chatsData.selectedConversation;

function useChangeDocumentTitle() {
  const selectedConversation = useSelector(getSelectedConversation);
  const location = useLocation();

  const isInChatPage = matchPath(
    { path: routes.chats, end: false },
    location.pathname
  );

  useEffect(() => {
    const username = isInChatPage && selectedConversation?.user?.name;
    const usernameText =
      typeof username === "number" ? `کاربر ${username}` : username;

    const newTitle = username
      ? `مکالمه ${usernameText}`
      : "اپلیکیشن تحت وب رایچت";

    document.title = newTitle;
  }, [selectedConversation, isInChatPage]);
}

export default useChangeDocumentTitle;
